import { DatePipe } from "@angular/common";
import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import {
  MENU_BUTTON_CODE,
  MENU_BUTTON_STYLE,
  c1,
} from "src/app/core/services/constants";
import { IndexDBService } from "src/app/core/services/indexDB.service";
import { ButtonOption, MenuButton, Tab } from "src/app/core/services/interface";
import { MiddlwareService } from "src/app/core/services/middleware.service";
import { WebsocketService } from "src/app/core/services/websocket.service";
import { BuilderService } from "src/app/sharedservices/builder.service";
import { CommonService } from "src/app/sharedservices/common.service";

@Component({
  selector: "app-button-web-datepicker",
  templateUrl: "./button-web-datepicker.component.html",
  styleUrls: ["./button-web-datepicker.component.scss"],
})
export class ButtonWebDatepickerComponent implements OnInit, OnDestroy {
  constructor(
    private ws: WebsocketService,
    private mdw: MiddlwareService,
    public indexDBService: IndexDBService,
    public builderService: BuilderService,
    private formBuilder: UntypedFormBuilder,
    private datePipe: DatePipe,
    private commonService: CommonService
  ) {}

  @Input() button: MenuButton;
  @Input() row_id: string;
  @Input() fontSmaller = false;

  @Input() mode: string;
  @Input() fontResize = false;
  @Input() data: Tab;
  @Input() colors: any;
  @Input() no_buttons = 1;
  @Input() ref: any;
  //////////////////// what have been used //////////////

  currentMenuSubscription: any;
  updateBuilderComponentSubscription: any;
  offCanvasSubscription: any;
  colorsComponentSubscription: any;
  formSubscribtion: any;

  helper: string; // = 'Helper Text';
  error: string; //'error';  error messages

  helper_color: string; //='#8e8e93'
  error_color: string; //= '#FF0000' ;
  leading_icon: string = null; // 'fas fa-heart' ;
  trailing_icon: string = null; //= 'fas fa-check-circle';
  error_icon: string = "fas fa-exclamation-circle";
  leading_icon_color: string;
  trailing_icon_color: string;

  upArrow_icon: string = "bx bx-caret-up";
  downArrow_icon: string = "bx bx-caret-down";
  downArrow_icon_ios: string = "mdi mdi-chevron-down-box";

  option_selected_icon_ios = "fas fa-check";

  suffix: string;
  suffix_color: string;
  prefix: string;
  prefix_color: string;

  border_color: string;
  border_color_ios: string;

  option_active_bg_color: string;

  bg_image: string;
  bg_color: string;
  start_color: string;
  end_color: string;
  image: string;
  album_button: any;
  albums: any;
  emptyImage: string;
  emptyImageP0: string;
  emptyImageP1: string;
  widthP0: string;
  label: string;
  sublabel: string;
  label_color: string;
  sublabel_color: string;
  settings: any;
  primary_color: string;
  active_icon_color_ios: string;
  pStyle: number;
  cellHeight: string;
  labellPadding: string;
  sublabelPadding: string;
  padding: string;
  album_input_map: any;
  sublabelSetting: any;
  dateSetting: any;
  datePadding: any;

  labelSetting: any;
  isAndroid: boolean;
  current_button: any;
  isActive: boolean;
  optionSetting: any;
  optionPadding: any;
  options: any;
  border_default_color: string; // = '#B8B8B8';
  activeOption: any;
  outline: string;
  menu_bg_color: string;
  hint: string;
  inputText: any;
  inputText_color: string;

  /// colors to be common into the tab section///
  light: boolean = true;
  color_schema: any;
  color_schema_ios: any;
  date: any;
  formate: string;
  dateForm: UntypedFormGroup;
  errorMsgList = {};

  ngOnInit() {
    let style = this.isAndroid
      ? this.button.button_style
      : this.button.button_style_ios;
    this.initialize(style, this.no_buttons);
    this.date = new Date();

    this.dateForm = this.formBuilder.group({
      value: new UntypedFormControl(),
    });

    this.currentMenuSubscription = this.mdw.currentMenuContainer$.subscribe(
      (data) => {
        if (data && !data.fromButton) {
          if (data["sortedButtonList"][this.row_id]) {
            this.no_buttons =
              data["sortedButtonList"][this.row_id].length > 0
                ? data["sortedButtonList"][this.row_id].length
                : 1;
            this.current_button = data["currentButton"];
            this.isActive =
              this.current_button &&
              this.current_button.button_id == this.button.button_id
                ? true
                : false;

            let style = this.isAndroid
              ? this.button.button_style
              : this.button.button_style_ios;
            this.initialize(style, this.no_buttons);
          }

          if (data["colors"]) {
            this.colors = data["colors"];
            this.light = data["light"];
            this.color_schema = this.light
              ? this.colors.color_schema.schemes.light
              : this.colors.color_schema.schemes.dark;
            this.color_schema_ios = this.light
              ? this.colors.color_schema_ios.schemes.light
              : this.colors.color_schema_ios.schemes.dark;
          }

          let style = this.isAndroid
            ? this.button.button_style
            : this.button.button_style_ios;
          this.initialize(style, this.no_buttons);
        }
      }
    );

    this.colorsComponentSubscription =
      this.mdw.colorsComponentContainer$.subscribe((data) => {
        if (
          data &&
          data.color_schema &&
          data.color_schema_ios &&
          data.light != null
        ) {
          this.colors = data;
          this.light = data.light;
          let style = this.isAndroid
            ? this.button.button_style
            : this.button.button_style_ios;
          this.initialize(style, this.no_buttons);
        }
      });

    this.offCanvasSubscription = this.mdw.offCanvasContainer$.subscribe(
      (data) => {
        // only for getting default button to change style for active or none active button style

        if (data && data.button) {
          this.current_button = data.button;
          this.isActive =
            this.current_button &&
            this.current_button.button_id == this.button.button_id
              ? true
              : false;
          let style = this.isAndroid
            ? this.button.button_style
            : this.button.button_style_ios;
          this.initialize(style, this.no_buttons);
        }
      }
    );

    this.updateBuilderComponentSubscription =
      this.mdw.updateBuilderComponentContainer$.subscribe((data) => {
        if (data && data.tab) {
          // only to get different views for button for Android and iOS. if both same view we do not need this subscription.

          this.isAndroid =
            localStorage.getItem("mode")[0] == c1.ANDROID ? true : false;
          let style = this.isAndroid
            ? this.button.button_style
            : this.button.button_style_ios;
          this.initialize(style, this.no_buttons);
        }
      });
  }

  get f() {
    return this.dateForm.controls;
  }

  initialize(style, no_button) {
    this.isAndroid =
      localStorage.getItem("mode")[0] === c1.ANDROID ? true : false;
    if (this.button) {
      const validators = [];
      if (
        this.button.button_validations &&
        this.button.button_validations.length > 0
      ) {
        this.button.button_validations.forEach((v) => {
          this.errorMsgList[v.type] = v.message;
          switch (v.type) {
            case "required":
              validators.push(Validators.required);
              break;
            case "minlength":
              validators.push(Validators.minLength(v.min));
              break;
            case "maxlength":
              validators.push(Validators.maxLength(v.max));
              break;
            case "pattern":
              validators.push(Validators.pattern(v.pattern));
              break;
            // Add more cases as needed
          }
        });
      }
      const date =
        this.button.button_value &&
        this.button.button_value.length > 0 &&
        this.button.button_value[0].value
          ? this.commonService.parseAndFormatDate(
              this.button.button_value[0].value,
              this.button.button_picker.format
            )
          : "";
      this.dateForm = this.formBuilder.group({
        value: new UntypedFormControl(date, validators),
      });

      if (this.button?.button_disable) {
        this.dateForm.get("value").disable();
      } else {
        this.dateForm.get("value").enable();
      }

      this.formSubscribtion = this.dateForm.valueChanges.subscribe((value) => {
        this.onChange();
      });
    }
  }

  onChange() {
    if (this.dateForm.valid) {
      let val: ButtonOption = {
        id: this.button.button_id,
        value: this.dateForm.value.value
          ? this.datePipe.transform(
              this.dateForm.value.value,
              this.button.button_picker.format
            )
          : "",
      };
      this.button.button_value = [val];
      this.updateButtonData();
    }
  }

  updateButtonData() {
    this.mdw.changeTab(
      { button: this.button, tab: { module: "menu" } },
      this.mode,
      true,
      true,
      false,
      this.ref
    );
  }

  ngOnDestroy(): void {
    if (this.updateBuilderComponentSubscription) {
      this.updateBuilderComponentSubscription.unsubscribe();
    }
    if (this.currentMenuSubscription) {
      this.currentMenuSubscription.unsubscribe();
    }

    if (this.offCanvasSubscription) {
      this.offCanvasSubscription.unsubscribe();
    }

    if (this.colorsComponentSubscription) {
      this.colorsComponentSubscription.unsubscribe();
    }
    if (this.formSubscribtion) {
      this.formSubscribtion.unsubscribe();
    }
  }
}
